export function removeTokenPrefix(token: string, tokenType: string): string {
  if (!token || !tokenType || typeof token !== "string") {
    return token;
  }

  return token.replace(`${tokenType} `, "");
}
